export const categories = [
  {
    id: "jiaoyu",
    name: "教育学习",
    slug: "jiaoyu",
    description: "汇聚优质教育视频，助力终身学习与成长",
    icon: "ri-graduation-cap-line",
    color: "bg-amber-100 text-amber-700",
    videoCount: 128,
  },
  {
    id: "yule",
    name: "娱乐影视",
    slug: "yule",
    description: "精彩影视、综艺、短片，放松身心的视听盛宴",
    icon: "ri-movie-2-line",
    color: "bg-rose-100 text-rose-700",
    videoCount: 256,
  },
  {
    id: "shenghuo",
    name: "生活方式",
    slug: "shenghuo",
    description: "美食、旅行、家居、时尚，发现生活之美",
    icon: "ri-heart-line",
    color: "bg-emerald-100 text-emerald-700",
    videoCount: 189,
  },
  {
    id: "zhichang",
    name: "职场技能",
    slug: "zhichang",
    description: "提升职业竞争力，掌握前沿职场技能",
    icon: "ri-briefcase-line",
    color: "bg-sky-100 text-sky-700",
    videoCount: 97,
  },
  {
    id: "keji",
    name: "科技数码",
    slug: "keji",
    description: "最新科技资讯、产品测评、数码教程",
    icon: "ri-smartphone-line",
    color: "bg-violet-100 text-violet-700",
    videoCount: 143,
  },
  {
    id: "yinyue",
    name: "音乐艺术",
    slug: "yinyue",
    description: "音乐演出、艺术创作、文化传承",
    icon: "ri-music-line",
    color: "bg-orange-100 text-orange-700",
    videoCount: 112,
  },
  {
    id: "tiyu",
    name: "体育运动",
    slug: "tiyu",
    description: "赛事集锦、运动教程、健身指导",
    icon: "ri-run-line",
    color: "bg-teal-100 text-teal-700",
    videoCount: 86,
  },
  {
    id: "yuanchuang",
    name: "原创精品",
    slug: "yuanchuang",
    description: "平台独家原创内容，品质保证",
    icon: "ri-star-line",
    color: "bg-yellow-100 text-yellow-700",
    videoCount: 64,
  },
];